import './Visual.scss';

export default function Visual() {
	return <figure>Visual</figure>;
}
